import React from 'react';
import Reports from "@containers/reports/Reports";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {BREADCRUMBS_REPORTS} from "@pages/reports/constants/breadcrumbs";

const ReportsPage = () => {

    return (
        <PageLayout
            breadcrumbs={BREADCRUMBS_REPORTS}
        >
            <Reports/>
        </PageLayout>
    )
};

export default ReportsPage;